import React from 'react';
import { Grid } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import SystemAdherenceCard from './SystemAdherenceCard';
import AppUsageEvolutionCard from './AppUsageEvolutionCard';
import PunchCardDetailsCard from './PunchCardDetailsCard';

const useStyles = makeStyles((_theme: Theme) =>
  createStyles({
    mainContentContainer: {
      overflowX: 'hidden',
      width: '100%',
      overflowY: 'auto',
      height: 'calc(100vh - 135px)',
      display: 'flex',
      margin: 0,
    },
  }),
);

const ManagementPanel: React.FC = () => {
  const classes = useStyles();

  return (
    <Grid className={classes.mainContentContainer} container spacing={2}>
      <Grid container item spacing={2}>
        <Grid item xs md={6}>
          <SystemAdherenceCard />
        </Grid>
        <Grid item xs md={6}>
          <AppUsageEvolutionCard />
        </Grid>
      </Grid>

      <Grid container item spacing={2}>
        <Grid item xs md={6}>
          <PunchCardDetailsCard />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ManagementPanel;
